export default __webpack_public_path__ + "static/media/pollfish.749de14c.png";